import React, { Component } from 'react';

import RingLoader from "react-spinners/RingLoader";

import IssuerView from './issuer-view.js';
import VerifierView from './verifier-view.js';

import logo from '../assets/logo192.png';
class Root extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			build_version: null,
			view: 'issuerr',
			config: {},
			widget_params: {},
			loaded: false
		}
	}

	// post render commit phase
	componentDidMount() {
		console.log('Root.componentDidMount called');
		
		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}

	async checkNavigationState() {
		console.log('SpeakerHomeView.checkNavigationState called');

		try {
			const URL = require("url");
			let url = window.location.href;
			url = url.replace('#/', '/');
			let {query} = URL.parse(url, true);

			let view = 'issuer';

			if (query.view === 'verifier')
			view = 'verifier';

			// first read boot strap config
			let _config = {};
			let boot_config = await this.loadConfig('boot_webapp');

			if (boot_config && boot_config[view])
			Object.assign(_config, boot_config[view]);

			// see if there is a remote overload
			if (boot_config && boot_config[view] && boot_config[view].remote_config_endpoint) {
				let remote_config = await this.fetchRemoteConfig(boot_config[view].remote_config_endpoint);

				if (remote_config)
				Object.assign(_config, remote_config);
			}
			
			// then read widget params with deployment
			let _did_widget_params = {
				description: (query.view === 'issuer' ? "issuer did widget specification" : "verifier did widget specification"),
				widget: "connect"
			};

			let default_widget_params = (boot_config && boot_config[view] && boot_config[view].default_widget_params ? boot_config[view].default_widget_params : {});

			if (default_widget_params)
			Object.assign(_did_widget_params, default_widget_params);

			// set widget params in component

			// build number
			let manifest_json = await this.loadJson('manifest');
			let version_number = manifest_json.version;


			this.setState({view, loaded: true, build_version: version_number, config: _config, widget_params: _did_widget_params});

		}
		catch(e) {
			console.log('exception in Root.checkNavigationState: ' + e);
		}
	}

	// functions
	async loadJson(configname) {
		const _$ = require('jquery');

		let jsonfile = configname + '.json';

		let config_json = await new Promise((resolve, reject) => { 
			_$.getJSON(jsonfile, function(res) {
				if (res) resolve(res); else reject('no data');
			})
			.catch(err => {
				console.log('exception in loadJson: ' + err);
				reject('no data');
			});
		})
		.catch(err => {
			console.log('exception in loadJson: ' + err);
		});

		return config_json;
	}
	
	async loadConfig(configname) {
		const _$ = require('jquery');

		return  this.loadJson('./config/' + configname);
	}

	async fetchJson(endpoint) {
		try {
			let res = await new Promise((resolve, reject) => {
				let xhttp = new XMLHttpRequest();

				xhttp.open('GET', endpoint.url, true);
				
				// header
				switch(endpoint.content_type) {
					case 'static':
						break;

					default:
						xhttp.setRequestHeader("Content-type", "application/json");
						break;
				}

				xhttp.send();
				
				xhttp.onload = function(e) {
					if (xhttp.status == 200) {
						var res = {};
						
						try {
							res = JSON.parse(xhttp.responseText);
						}
						catch(e) {
						}
	
						resolve(res);
					}
					else {
						reject('wrong result');
					}
				};
				
				xhttp.onerror = function (e) {
					reject('rest error is ' + xhttp.statusText);
				};
			})
			.catch(err => {
			});

			return res;
		}
		catch(e) {
		}

	}

	async fetchRemoteConfig(remote_config_endpoint) {
		if (remote_config_endpoint || !remote_config_endpoint.url)
		return;

		let remote_config = await this.fetchJson(remote_config_endpoint);

		return remote_config;
	}

	render() {
		if (this.state.loaded === false) {
			return (
				<div id='Root' className="Root">
					<RingLoader />
				</div>
			);
		}

		const params = {build_version: this.state.build_version, config: this.state.config, widget_params: this.state.widget_params}

		return (
			<div id='Root' className="Root">
				{(this.state.view === 'issuer' ?  <IssuerView root={this} params={params} /> : <VerifierView root={this}  params={params} />)}

				<img src={logo} className="Logo" alt="Patronymus" />
				<div className="Version">version: {this.state.build_version}</div>
			</div>
		);
	}
}


export default Root;
	